import React, { useContext, useEffect, useState, useRef } from "react";
import { DashboardContext } from "context/DashboardContext";
import { ModalContext } from "context/ModalContext";
import { api_srv } from "services";
import { show_toast } from "utils/helpers";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { fetchConfiguredUnderwriters} from "services/apiSrv";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { list_subclass } from "services/apiSrv";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { fetch_product_details } from "services/apiSrv";

export default function Edit_Benefit({ fetchBenefits = () => {} }) {
  const [imageUrl, setImageUrl] = useState("");
  const fileUrlRef = useRef(null);
  const queryClient = useQueryClient();
  const { id: productSystemRef } = useParams();
  console.log("product system ref", productSystemRef)

  const { data: productData, isProductLoading, isProductError, errorProduct, refetch } = useQuery({
    queryKey: ['productDetails', productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
    select: (res) => res?.data
  });
   
  let product = productData?.[0]
  console.log("product", product)

  // File upload function
  const uploadProductImage = async (options) => {
    const { onSuccess, onError, file } = options;

    try {
      let res = await (await api_srv).upload_api("productimage", file);
      setImageUrl(res.data[0].fileUrl);
      fileUrlRef.current = res.data[0].fileUrl;
      onSuccess(res.fileUrl);
      show_toast(`${file.name} uploaded successfully.`, "success");
      return res.data[0].fileUrl;
    } catch (err) {
      console.error("File upload error:", err);
      onError(err);
      show_toast(`${file.name} upload failed.`, "error");
    }
  };

  const [dmvics, setDmvics] = useState([{ name: "DMVIC 001", id: "01" }]);
  const { productmgt, setProductsmgt } = useContext(DashboardContext);
  const { modalClose } = useContext(ModalContext);
  const history = useHistory();

  //   useEffect(() => {
  //   setProductsmgt(prev => ({
  //     ...prev,
  //     productSystemRef: productSystemRef
  //   }));
  // }, []);  

  console.log("product managements===", productmgt)


  

  function handleProductsMgtChange(evt) {
    const { value, name, type, checked } = evt.target;
    console.log(`Input changed - Name: ${name}, Value: ${value}, Type: ${type}, Checked: ${checked}`);

    if (type === "checkbox") {
      if (["charges", "salesChannel", "currency", "period"].includes(name)) {
        setProductsmgt((prev) => {
          const currentValues = Array.isArray(prev[name]) ? prev[name] : [];
          const updatedValues = checked
            ? [...currentValues, value]
            : currentValues.filter((item) => item !== value);
          console.log(`Updated ${name} array:`, updatedValues);
          return { ...prev, [name]: updatedValues };
        });
      } else {
        console.log(`Setting ${name} to ${checked ? value : ""}`);
        setProductsmgt({
          ...productmgt,
          [name]: checked ? value : "",
        });
      }
    } else if (type === "radio" && name === "period") {
      console.log(`Setting period to: ${value}`);
      setProductsmgt({
        ...productmgt,
        [name]: value,
      });
    } else if (name === "ratetype") {
      console.log(`Setting rateType to: ${value}`);
      setProductsmgt({
        ...productmgt,
        rate: { ...productmgt.rate, rateType: value },
      });
    } else if (name === "rateValue") {
      const parsedValue = isNaN(parseFloat(value)) ? "" : parseFloat(value);
      console.log(`Setting rateValue to: ${parsedValue}`);
      setProductsmgt({
        ...productmgt,
        rate: { ...productmgt.rate, value: parsedValue },
      });
    } else {
      console.log(`Setting ${name} to: ${value}`);
      setProductsmgt({
        ...productmgt,
        [name]: value,
      });
    }
  }
useEffect(() => {
  // Early return if we don't have usable data yet
  if (!product || isProductLoading || isProductError) return;

  // Helper to safely convert numbers/strings to form-compatible values
  const safeString = (value: any): string => 
    value != null ? String(value) : "";

  const safeNumberString = (value: any): string => 
    typeof value === 'number' && !isNaN(value) ? String(value) : "";

  const safeArray = (value: any): string[] => 
    Array.isArray(value) ? value.map(String) : [];

  setProductsmgt({
    // Core identification & text fields
    name: product.productName?.trim() || "",
    description: product.productDescription?.trim() || "",
    ref: product.productInternalRef?.trim() || "",

    // Category & class (your form expects uppercase?)
    category: (product.insuranceCategory || "").toUpperCase(),
    insuranceclass: safeString(product.insuranceClass),

    // Relations
    underwriter: safeString(product.underwriterSystemRef),
    coverType: safeString(product.covertypeSystemRef),

    // Commission – careful with floating point
    commission: safeNumberString(product.productCommision),

    // Image
    productImage: product.productLogo || "",

    // Premium range
    premiumMin: safeNumberString(product.productPremium?.minimum),
    premiumMax: safeNumberString(product.productPremium?.maximum),

    // Cover period
    coverPeriodMin: safeNumberString(product.productCover?.minimum),
    coverPeriodMax: safeNumberString(product.productCover?.maximum),

    // Arrays – make sure they're arrays of strings (most selects expect strings)
    currency: safeArray(product.supportedCurrency),
    salesChannel: safeArray(product.productSalesChannel),
    charges: safeArray(product.productCharges),
    
    // Supported periods – your form uses string values like "30", "360"
    period: safeArray(product.productCover?.supportedPeriods),

    // Rate object
    rate: {
      rateType: product.basePremiumRate?.rateType === "percentage" 
        ? "percentage" 
        : "fixed", // fallback to fixed if unknown
      value: typeof product.basePremiumRate?.value === 'number' 
        ? product.basePremiumRate.value 
        : 0,
    },

    // Fields your form has but not clearly in this payload
    ira_code: "",           // still missing in the example response

    // Reset transient state
    loading: false,
  });

  // Handle image preview
  if (product.productLogo) {
    setImageUrl(product.productLogo);
    fileUrlRef.current = product.productLogo;
  } else {
    // Optional: clear preview when there's no logo
    setImageUrl("");
    fileUrlRef.current = null;
  }

}, [product, isProductLoading, isProductError, setProductsmgt, setImageUrl]);
  async function fetchcommisions(){
    const res = await (await api_srv).list_commissions()
    return res?.data || []
  }

  useEffect(() => {
    console.log("Current productmgt state:", productmgt);
  }, [productmgt]);


  const { data: commissions = [], isLoading, isError, error } = useQuery({
    queryKey: ["commissions"],
    queryFn: fetchcommisions,
  });

  console.log("Commissions data:", commissions);

  const handleFileUpload = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected for upload:", file.name);
      uploadProductImage({
        file,
        onSuccess: (fileUrl) => {
          console.log("File upload successful, URL:", fileUrl);
          setProductsmgt({
            ...productmgt,
            productImage: fileUrlRef.current,
          });
          setFieldValue("productImage", fileUrlRef.current);
        },
        onError: (err) => {
          console.error("Upload error:", err);
        },
      });
    }
  };

  const addProduct = async (values, { resetForm }) => {
    console.log("Form submitted with values:", values);
    setProductsmgt({ ...productmgt, productSystemRef: productSystemRef, loading: true });
    try {
      let resp = await (await api_srv).update_product(productmgt, productSystemRef);
      queryClient.invalidateQueries({ queryKey: ['products'] });

      console.log("Product creation response:", resp);
      setProductsmgt({ ...productmgt, loading: false });
      fetchBenefits();
      modalClose();
      show_toast(`Product ${productmgt.name} has been added`, "success");
      history.push('/dashboard/setup/products');
      
      // Reset the form to initial values
      resetForm();
      
      // Reset the productmgt context state
      setProductsmgt({
        name: "",
        description: "",
        period: [],
        commission: "",
        ref: "",
        underwriter: "",
        productImage: "",
        premiumMin: "",
        premiumMax: "",
        coverType: "",
        salesChannel: [],
        category: "",
        ira_code: "",
        charges: [],
        currency: [],
        rate: { rateType: "", value: 0 },
        insuranceclass: "",
        coverPeriodMin: "",
        coverPeriodMax: "",
        loading: false,
        productSystemRef: product.productSystemRef
      });
    } catch (err) {
      console.error("Product creation error:", err);
      setProductsmgt({ ...productmgt, loading: false });
      modalClose();
    }
  };

  const initialize = async () => {
    try {
      let type_resp = await (await api_srv).list_benefit_types();

      setDmvics(type_resp.types);
    } catch (err) {
      console.error("Error fetching benefit types:", err);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const fetch_subclass = async () => {
    const resp = await list_subclass();

    if (productmgt?.category) {
      const categoryUpper = productmgt.category.toUpperCase();

      return resp.data.filter((subclass) =>
        subclass.class_code?.toUpperCase() === categoryUpper
      );
    }

    return resp.data; 
  };

  const { data: subclasses, isLoading: isSubclassLoading, isSuccess } = useQuery({
    queryKey: ["subclasses", productmgt?.category], 
    queryFn: fetch_subclass,
    enabled: !!productmgt?.category, 
  });
  

  const {
    data: underwriters,
    isLoading: isLoadingUnderwriter,
    isError: isUnderwritersError,
    error: underwiterError,
  } = useQuery({
    queryKey: ["underwriters"],
    queryFn: fetchConfiguredUnderwriters,
    retry: 2,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  async function get_charges() {
    let resp = await (await api_srv).list_charges();
    console.log("Charges response:", resp);
    return resp.data;
  }

  const { data: charges, isLoading: chargeIsLoading, isError: chargeIsError, error: chargeError } = useQuery({
    queryKey: ["charges"],
    queryFn: get_charges,
  });

  // Derive cover types from selected subclass
  const selectedSubclass = subclasses?.find(
    (sub) => sub.ira_code === productmgt?.insuranceclass

  );
  const coverTypes = selectedSubclass?.insurancecovertypes || [];

  return (
<div className="p-4 bg-white rounded ">
       Editing  Product
      <Formik
        enableReinitialize
        initialValues={{
          ...productmgt,
          charges: productmgt?.charges || [],
          period: productmgt?.period || [],
          salesChannel: productmgt?.salesChannel || [],
          currency: productmgt?.currency || [],
          rate: productmgt?.rate || { rateType: "", value: 0 },
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Benefit Name is required"),
          description: Yup.string().required("Description is required"),
          period: Yup.array().min(1, "Please select at least one period").required("Please select at least one period"),
          commission: Yup.string().required("Commission is required"),
          ref: Yup.string().required("Reference is required"),
          underwriter: Yup.string().required("Please select an underwriter"),
          productImage: Yup.string().required("Please upload product for an image"),
          premiumMin: Yup.number().required("Minimum premium is required").min(0, "Minimum premium must be positive"),
          premiumMax: Yup.number()
            .required("Maximum premium is required")
            .min(Yup.ref("premiumMin"), "Maximum premium must be greater than minimum"),
          coverType: Yup.string().required("Please select a cover type"),
          salesChannel: Yup.array().min(1, "Please select at least one sales channel").required("Please select a sales channel"),
          category: Yup.string().required("Please select a category"),
          charges: Yup.array().min(1, "Please select at least one charge").required("Please select a charges option"),
          currency: Yup.array().min(1, "Please select at least one currency").required("Please select a currency"),
          rate: Yup.object().shape({
            rateType: Yup.string().required("Please select a rate type"),
            value: Yup.number()
              .typeError("Rate value must be a number")
              .required("Rate value is required")
              .min(0, "Rate value must be positive"),
          }),
          insuranceclass: Yup.string().required("Please select a Class"),
          coverPeriodMin: Yup.number().required("Please select a minimum cover period"),
          coverPeriodMax: Yup.number().required("Please select a maximum cover period"),
        })}
        onSubmit={(values, formikHelpers) => addProduct(values, formikHelpers)}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form className="mb-3">
            {/* Product Information Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Product Information</h3>
              <div className="row row-cols-1 row-cols-lg-3 g-3">
                <div className="col">
                  <label htmlFor="name" className="form-label" style={{ color: '#666666' }}>
                    Product Name
                  </label>
                  <input
                    name="name"
                    type="text"
                    value={productmgt?.name || ""}
                    onChange={handleProductsMgtChange}
                    className={`form-control ${errors.name && touched.name ? "is-invalid" : ""}`}
                    aria-label="Product Name"
                  />
                  <ErrorMessage name="name" component="div" className="invalid-feedback" />
                </div>
                <div className="col">
                  <label htmlFor="category" className="form-label" style={{ color: '#666666' }}>
                    Category
                  </label>
                  <select
                    name="category"
                    onChange={handleProductsMgtChange}
                    value={productmgt?.category || ""}
                    className={`form-select form-control w-100 ${errors.category && touched.category ? "is-invalid" : ""}`}
                    aria-label="Category"
                  >
                    <option value="">Select Category</option>
                    <option value="GENERAL">General</option>
                    <option value="LONG-TERM">Life</option>
                  </select>
                  <ErrorMessage name="category" component="div" className="invalid-feedback" />
                </div>
                <div className="col">
                  <label htmlFor="insuranceclass" className="form-label" style={{ color: '#666666' }}>
                    Insurance Class
                  </label>
                  <select
                    name="insuranceclass"
                    onChange={handleProductsMgtChange}
                    value={productmgt?.insuranceclass || ""}
                    className={`form-select form-control w-100 ${errors.insuranceclass && touched.insuranceclass ? "is-invalid" : ""}`}
                    aria-label="Insurance Class"
                  >
                    <option value="">Select Insurance Class</option>
                    {subclasses?.map((subclass) => (
                      <option value={subclass.ira_code} key={subclass.ira_code}>
                        {subclass.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage name="insuranceclass" component="div" className="invalid-feedback" />
                </div>
              </div>
            </div>

            {/* Financial Details Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Financial Details</h3>
              <div className="row row-cols-1 row-cols-lg-3 g-3">
                <div className="col">
                  <label htmlFor="commission" className="form-label" style={{ color: '#666666' }}>
                    Commission
                  </label>
                  <select
                    name="commission"
                    // onChange={(e) => {
                    //   handleProductsMgtChange(e);
                    //   setFieldValue("commission", e.target.value);
                    // }}
                    onChange={(e) => {
                      handleProductsMgtChange(e);
                      setFieldValue("commission", e.target.value);
                    }}
                    value={productmgt?.commission}
                    className={`form-select form-control w-100 ${errors.commission && touched.commission ? "is-invalid" : ""}`}
                    disabled={isLoading || isError}
                    aria-label="Commission"
                  >
                    <option value="">Select Commission</option>
                    {commissions?.map((c) => (
                      <option value={c.commissionRate} key={c.commisionSystemRef}>
                        {c.commissionRate}% {c.commisionName && ` - ${c.commisionName}`}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage name="commission" component="div" className="invalid-feedback" />
                </div>
                <div className="col">
                  <label htmlFor="ref" className="form-label" style={{ color: '#666666' }}>
                    Reference
                  </label>
                  <input
                    name="ref"
                    type="text"
                    value={productmgt?.ref || ""}
                    onChange={handleProductsMgtChange}
                    className={`form-control ${errors.ref && touched.ref ? "is-invalid" : ""}`}
                    aria-label="Reference"
                  />
                  <ErrorMessage name="ref" component="div" className="invalid-feedback" />
                </div>
                <div className="col">
                  <label htmlFor="productImage" className="form-label fw-semibold" style={{ color: '#666666' }}>
                    Product Image
                  </label>
                  <div
                    style={{
                      border: "1px dashed #ccc",
                      padding: "1rem",
                      borderRadius: "4px",
                      textAlign: "center",
                      background: "#f8f9fa",
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      if (file) handleFileUpload({ target: { files: [file] } }, setFieldValue);
                    }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      name="productImage"
                      onChange={(event) => handleFileUpload(event, setFieldValue)}
                      style={{ fontSize: "14px", display: "none" }}
                      id="productImageInput"
                    />
                    <label htmlFor="productImageInput" style={{ cursor: "pointer", fontSize: "14px", color: "#555" }}>
                      Drag & drop an image or click to upload
                    </label>
                    {productmgt?.productImage && (
                      <div className="mt-2" style={{ fontSize: "14px", color: "#555" }}>
                        <img
                          src={productmgt.productImage}
                          alt="Product Preview"
                          style={{ maxWidth: "100px", borderRadius: "4px" }}
                        />
                      </div>
                    )}
                  </div>
                  <ErrorMessage
                    name="productImage"
                    component="div"
                    className="invalid-feedback d-block"
                    style={{ fontSize: "14px", color: "#dc3545" }}
                  />
                </div>
              </div>
            </div>

            {/* Coverage Details Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Coverage Details</h3>
              <div className="row row-cols-1 row-cols-lg-3 g-3">
                <div className="col">
                  <label htmlFor="coverType" className="form-label" style={{ color: '#666666' }}>
                    Cover Type
                  </label>
                  <select
                    name="coverType"
                    onChange={handleProductsMgtChange}
                    value={productmgt?.coverType || ""}
                    className={`form-select form-control w-100 ${errors.coverType && touched.coverType ? "is-invalid" : ""}`}
                    aria-label="Cover Type"
                  >
                    <option value="">Select Cover Type</option>
                    {coverTypes?.map((cover) => (
                      <option value={cover.system_covertype_ref} key={cover.system_covertype_ref}>
                        {cover.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage name="coverType" component="div" className="invalid-feedback" />
                </div>
                {/* <div className="col">
                  <label htmlFor="underwriter" className="form-label" style={{ color: '#666666' }}>
                    Underwriters
                  </label>
                  <select
                    name="underwriter"
                    onChange={(e) => {
                      handleProductsMgtChange(e);
                      setFieldValue("underwriter", e.target.value);
                    }}
                    value={productmgt?.underwriter || ""}
                    className={`form-select form-control w-100 ${errors.underwriter && touched.underwriter ? "is-invalid" : ""}`}
                    disabled={isLoadingUnderwriter}
                    aria-label="Underwriter"
                  >
                    <option value="">Select Underwriter</option>
                    {underwriters?.data.length > 0 && underwriters?.data?.map((underwriter) => (
                      <option value={underwriter?.underwriterSystemRef} key={underwriter?.underwriterSystemRef}>
                        {underwriter.name}
                      </option>
                    ))}
                  </select>
                  {isUnderwritersError && (
                    <div className="invalid-feedback d-block">
                      Error loading underwriters: {underwiterError?.message || "Please try again"}
                    </div>
                  )}
                  <ErrorMessage name="underwriter" component="div" className="invalid-feedback" />
                </div> */}
                <div className="col">
                  <label className="form-label fw-bold" style={{ color: '#666666' }}>Supported Currency</label>
                  <div className="d-flex flex-column gap-2">
                    {["USD", "KES"].map((currency) => (
                      <div className="form-check" key={currency}>
                        <input
                          className={`form-check-input ${errors.currency && touched.currency ? "is-invalid" : ""}`}
                          type="checkbox"
                          name="currency"
                          id={`currency${currency}`}
                          value={currency}
                          checked={productmgt?.currency?.includes(currency)}
                          onChange={handleProductsMgtChange}
                          aria-label={`Currency ${currency}`}
                        />
                        <label className="form-check-label tx-12" htmlFor={`currency${currency}`}>
                          {currency}
                        </label>
                      </div>
                    ))}
                  </div>
                  <ErrorMessage name="currency" component="div" className="invalid-feedback d-block" />
                </div>
              </div>
            </div>

            {/* Premium & Cover Period Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Premium & Cover Period</h3>
              <div className="row row-cols-1 row-cols-lg-4 g-3">
                <div className="col">
                  <label className="form-label fw-bold" >Premium Range</label>
                  <div>
                    <label htmlFor="premiumMin" className="form-label" style={{ color: '#666666' }}>
                      Minimum Premium
                    </label>
                    <input
                      name="premiumMin"
                      type="number"
                      value={productmgt?.premiumMin || ""}
                      onChange={handleProductsMgtChange}
                      className={`form-control ${errors.premiumMin && touched.premiumMin ? "is-invalid" : ""}`}
                      aria-label="Minimum Premium"
                    />
                    <ErrorMessage name="premiumMin" component="div" className="invalid-feedback" />
                  </div>
                </div>
                <div className="col">
                  <label className="form-label fw-bold d-block">&nbsp;</label>
                  <div>
                    <label htmlFor="premiumMax" className="form-label" style={{ color: '#666666' }}>
                      Maximum Premium
                    </label>
                    <input
                      name="premiumMax"
                      type="number"
                      value={productmgt?.premiumMax || ""}
                      onChange={handleProductsMgtChange}
                      className={`form-control ${errors.premiumMax && touched.premiumMax ? "is-invalid" : ""}`}
                      aria-label="Maximum Premium"
                    />
                    <ErrorMessage name="premiumMax" component="div" className="invalid-feedback" />
                  </div>
                </div>
                <div className="col">
                  <label className="form-label fw-bold" >Cover Period</label>
                  <div>
                    <label htmlFor="coverPeriodMin" className="form-label" style={{ color: '#666666' }}>
                      Minimum Cover Period
                    </label>
                    <select
                      name="coverPeriodMin"
                      onChange={handleProductsMgtChange}
                      value={productmgt?.coverPeriodMin || ""}
                      className={`form-select form-control w-100 ${errors.coverPeriodMin && touched.coverPeriodMin ? "is-invalid" : ""}`}
                      aria-label="Minimum Cover Period"
                    >
                      <option value="">Select Minimum Cover Period</option>
                      <option value={1}>1 Day</option>
                      <option value={7}>7 Days</option>
                      <option value={30}>1 Month</option>
                      <option value={180}>6 Months</option>
                      <option value={360}>1 Year</option>
                    </select>
                    <ErrorMessage name="coverPeriodMin" component="div" className="invalid-feedback" />
                  </div>
                </div>
                <div className="col">
                  <label className="form-label fw-bold d-block">&nbsp;</label>
                  <div>
                    <label htmlFor="coverPeriodMax" className="form-label" style={{ color: '#666666' }}>
                      Maximum Cover Period
                    </label>
                    <select
                      name="coverPeriodMax"
                      onChange={handleProductsMgtChange}
                      value={productmgt?.coverPeriodMax || ""}
                      className={`form-select form-control w-100 ${errors.coverPeriodMax && touched.coverPeriodMax ? "is-invalid" : ""}`}
                      aria-label="Maximum Cover Period"
                    >
                      <option value="">Select Maximum Cover Period</option>
                      <option value={1}>1 Day</option>
                      <option value={7}>7 Days</option>
                      <option value={30}>1 Month</option>
                      <option value={180}>6 Months</option>
                      <option value={360}>1 Year</option>
                    </select>
                    <ErrorMessage name="coverPeriodMax" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Settings Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Additional Settings</h3>
              <div className="row row-cols-1 row-cols-lg-4 g-4">
                <div className="col">
                  <label className="form-label fw-bold" style={{ color: '#666666' }}>Sales Channel</label>
                  <div className="d-flex flex-column gap-2">
                    {["web", "mobile", "ussd", "whatsapp"].map((channel) => (
                      <div className="form-check" key={channel}>
                        <input
                          className={`form-check-input ${errors.salesChannel && touched.salesChannel ? "is-invalid" : ""}`}
                          type="checkbox"
                          name="salesChannel"
                          id={`salesChannel${channel}`}
                          value={channel}
                          checked={productmgt?.salesChannel?.includes(channel)}
                          onChange={handleProductsMgtChange}
                          aria-label={`Sales Channel ${channel}`}
                        />
                        <label className="form-check-label tx-12" htmlFor={`salesChannel${channel}`}>
                          {channel.charAt(0).toUpperCase() + channel.slice(1)}
                        </label>
                      </div>
                    ))}
                  </div>
                  <ErrorMessage name="salesChannel" component="div" className="invalid-feedback d-block" />
                </div>
                <div className="col">
                  <label className="form-label fw-bold" style={{ color: '#666666' }}>Charges</label>
                  <div className="d-flex flex-column gap-2">
                    {charges?.map((charge) => (
                      <div className="form-check" key={charge.charge_code}>
                        <input
                          className={`form-check-input ${errors.charges && touched.charges ? "is-invalid" : ""}`}
                          type="checkbox"
                          name="charges"
                          id={`charges${charge.charge_code}`}
                          value={charge.charge_code}
                          checked={productmgt?.charges?.includes(charge.charge_code)}
                          onChange={handleProductsMgtChange}
                          aria-label={`Charge ${charge.charge_name}`}
                        />
                        <label className="form-check-label tx-12" htmlFor={`charges${charge.charge_code}`}>
                          {charge.charge_name}
                        </label>
                      </div>
                    ))}
                  </div>
                  <ErrorMessage name="charges" component="div" className="invalid-feedback d-block" />
                </div>
                <div className="col">
                  <label className="form-label fw-bold" style={{ color: '#666666' }}>Supported Cover Period</label>
                  <div className="d-flex flex-column gap-2">
                    {["1", "7", "30", "180", "360"].map((period) => (
                      <div className="form-check" key={period}>
                        <input
                          className={`form-check-input ${errors.period && touched.period ? "is-invalid" : ""}`}
                          type="checkbox"
                          name="period"
                          id={`period${period}`}
                          value={period}
                          checked={productmgt?.period?.includes(period)}
                          onChange={handleProductsMgtChange}
                          aria-label={`Cover Period ${
                            period === "1" ? "1 Day" : period === "7" ? "7 Days" : period === "30" ? "1 Month" : period === "180" ? "6 Months" : "1 Year"
                          }`}
                        />
                        <label className="form-check-label tx-12" htmlFor={`period${period}`}>
                          {period === "1" ? "1 Day" : period === "7" ? "7 Days" : period === "30" ? "1 Month" : period === "180" ? "6 Months" : "1 Year"}
                        </label>
                      </div>
                    ))}
                  </div>
                  <ErrorMessage name="period" component="div" className="invalid-feedback d-block" />
                </div>
              </div>
            </div>

            {/* Description & Rate Section */}
            <div className="mb-4">
              <h3 className="form-label fw-bold" style={ {fontWeight: "bold", paddingBottom: "6px", fontSize: "1.125em"}}>Description & Rate</h3>
              <div className="row row-cols-1 row-cols-lg-2 g-3">
                <div className="col">
                  <label htmlFor="description" className="form-label" style={{ color: '#666666' }}>
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={productmgt?.description || ""}
                    onChange={handleProductsMgtChange}
                    className={`form-control w-100 ${errors.description && touched.description ? "is-invalid" : ""}`}
                    rows="4"
                    aria-label="Description"
                  />
                  <ErrorMessage name="description" component="div" className="invalid-feedback" />
                </div>
                <div className="col">
                  <label className="form-label fw-bold" style={{ color: '#666666' }}>Base Rate</label>
                  <div className="d-flex flex-column gap-2">
                    <div className="form-check">
                      <input
                        className={`form-check-input ${errors.rate?.rateType && touched.rate?.rateType ? "is-invalid" : ""}`}
                        type="radio"
                        name="ratetype"
                        id="rateTypeFixed"
                        value="fixed"
                        checked={productmgt?.rate?.rateType === "fixed"}
                        onChange={handleProductsMgtChange}
                        aria-label="Fixed Rate"
                      />
                      <label className="form-check-label tx-12" htmlFor="rateTypeFixed">
                        Fixed
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className={`form-check-input ${errors.rate?.rateType && touched.rate?.rateType ? "is-invalid" : ""}`}
                        type="radio"
                        name="ratetype"
                        id="rateTypePercentage"
                        value="percentage"
                        checked={productmgt?.rate?.rateType === "percentage"}
                        onChange={handleProductsMgtChange}
                        aria-label="Percentage Rate"
                      />
                      <label className="form-check-label tx-12" htmlFor="rateTypePercentage" style={{ color: '#666666' }}>
                        Percentage
                      </label>
                    </div>
                    <div>
                      <label htmlFor="rateValue" className="form-label" style={{ color: '#666666' }}>
                        Rate Value
                      </label>
                      <input
                        name="rateValue"
                        type="number"
                        step="0.01"
                        value={productmgt?.rate?.value}
                        onChange={handleProductsMgtChange}
                        className={`form-control ${errors.rate?.value && touched.rate?.value ? "is-invalid" : ""}`}
                        placeholder="e.g., 12.34"
                        aria-label="Rate Value"
                      />
                      <ErrorMessage name="rate.value" component="div" className="invalid-feedback" />
                    </div>
                    <ErrorMessage name="rate.rateType" component="div" className="invalid-feedback d-block" />
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="d-flex justify-content-start mt-4">
              <button
                type="submit"
                disabled={productmgt?.loading}
                className="btn btn-success px-4 py-2 d-flex align-items-center"
              >
                {productmgt?.loading && (
                  <svg className="spinner-border spinner-border-sm me-2" viewBox="0 0 24 24" role="status">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25" />
                    <path
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      className="opacity-75"
                    />
                  </svg>
                )}
                {productmgt?.loading ? "Please wait..." : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}